const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTanimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    clipRule: "evenodd",
    d: "M1 7C1 5.34315 2.34315 4 4 4H20C21.6569 4 23 5.34315 23 7V9H22H2H1V7ZM1 11V17C1 18.6569 2.34315 20 4 20H20C21.6569 20 23 18.6569 23 17V11H22H2H1ZM16.5 12.208C16.1938 12.0742 15.8556 12 15.5 12C14.1193 12 13 13.1193 13 14.5C13 15.8807 14.1193 17 15.5 17C15.8556 17 16.1938 16.9258 16.5 16.792C16.8062 16.9258 17.1444 17 17.5 17C18.8807 17 20 15.8807 20 14.5C20 13.1193 18.8807 12 17.5 12C17.1444 12 16.8062 12.0742 16.5 12.208ZM5 14H9V12H5V14ZM9 17H5V15H9V17Z",
    fill: "black",
    fillRule: "evenodd",
    style: {
      fill: "#88b2f0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTanimg);
export default __webpack_public_path__ + "static/media/tanimg.0493dd40ed92b13bbcf4dec9deddd8d0.svg";
export { ForwardRef as ReactComponent };